export default __webpack_public_path__ + "static/media/hospital_icon.6510ca16.svg";